var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAbout = function SvgAbout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1046.357 -1520.063)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    rx: 4,
    transform: "translate(1046.357 1520.063)",
    fill: "#1dff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.173,1526.063a4.1,4.1,0,0,1,1.868.354,1.3,1.3,0,0,1,.675,1.272q0,1.624-2.525,1.624t-2.527-1.624Q1057.664,1526.064,1060.173,1526.063Zm2.454,4.748v8.9c0,.132-.347.238-1.039.316a18.946,18.946,0,0,1-2.13.117,5.91,5.91,0,0,1-1.406-.1c-.211-.066-.317-.176-.317-.333v-8.573q0-.4,1.021-.785a6.2,6.2,0,0,1,2.229-.388Q1062.627,1529.963,1062.627,1530.811Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAbout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/about.e3b9d2a6.svg";
export { ForwardRef as ReactComponent };